import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { authService } from '../services/auth';
import { toast } from '../hooks/use-toast';
import { Toaster } from '../components/ui/toaster';
import LandingNavbar from '../components/ui/LandingNavbar';
import BrandScroller from '../components/ui/BrandScroller';

const inputCls = "bg-gray-100/80 border-transparent text-gray-900 placeholder:text-gray-400 rounded-full h-14 px-6 text-base font-medium focus-visible:ring-0 focus-visible:ring-offset-0";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);
  const [success, setSuccess]   = useState(false);
  const [username, setUsername] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    if (!username.trim()) {
      setError('Por favor ingresa tu correo');
      setLoading(false);
      return;
    }

    try {
      const response = await authService.forgotPassword({ username: username.trim() });
      if (response.success) {
        setSuccess(true);
        toast({ title: 'Solicitud enviada', description: response.message || 'Revisa tu correo.' });
      }
    } catch (err) {
      const msg = err.message || 'Error al solicitar recuperación. Intenta nuevamente.';
      setError(msg);
      toast({ title: 'Error', description: msg, variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <LandingNavbar onBack={() => navigate('/login')} />
      <BrandScroller />

      <div className="flex-1 px-6 py-12 flex flex-col items-center">
        <div className="w-full max-w-md space-y-8">

          <div className="pt-4">
            <h1
              className="font-semibold text-black tracking-tight"
              style={{ fontSize: 'clamp(28px,6vw,44px)', letterSpacing: '-0.025em', lineHeight: 1.06 }}
            >
              Recuperar<br />contraseña
            </h1>
            <p className="text-gray-400 text-[15px] mt-3">
              Ingresa tu correo y te enviaremos un enlace de recuperación
            </p>
          </div>

          {success ? (
            <div className="space-y-6">
              <div className="bg-green-50 border border-green-200 rounded-2xl p-4">
                <p className="text-green-700 text-sm text-center leading-relaxed">
                  Si el correo existe en nuestro sistema recibirás las instrucciones en tu bandeja de entrada.
                </p>
              </div>
              <Button onClick={() => navigate('/login')}
                className="w-full bg-black text-white rounded-full h-14 text-base font-semibold hover:opacity-90 active:scale-95 transition-all">
                Volver al inicio de sesión
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Correo electrónico"
                className={inputCls}
                required
                autoFocus
              />

              {error && (
                <div className="bg-red-50 border border-red-200 rounded-2xl p-3">
                  <p className="text-red-500 text-sm text-center">{error}</p>
                </div>
              )}

              <Button type="submit" disabled={loading}
                className="w-full bg-black text-white rounded-full h-14 text-base font-semibold hover:opacity-90 active:scale-95 transition-all disabled:opacity-50">
                {loading ? 'Enviando...' : 'Enviar enlace'}
              </Button>
            </form>
          )}
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default ForgotPassword;
